import { BrandLogo, resolveStudioBrand } from '../lib/branding';

// ── PANTALLA DE CARGA ÚNICA ──────────────────────────────────────────────────
// Vivía dentro de App.js. Se extrajo para que el Portal del cliente pueda mostrar
// EXACTAMENTE la misma mientras su identidad todavía no resuelve, en vez de montar
// una segunda pantalla propia ("Estamos abriendo tu espacio") al desaparecer esta.
//
// Un solo estado visual de carga: Feria + barra, y después el destino real.
// El loader se va porque el estado está listo, nunca porque pasó un tiempo.
function getStoredTheme() {
  if (typeof window === 'undefined') return 'dark';
  return window.localStorage.getItem('feria_theme') || 'light';
}

export default function PantallaDeCarga() {
  const theme = getStoredTheme();
  const surfaceTone = theme === 'light' ? 'light' : 'dark';
  const isLightSurface = surfaceTone === 'light';
  const brand = resolveStudioBrand({ theme, surfaceTone });
  const background = isLightSurface ? '#ffffff' : '#000000';
  const primaryText = isLightSurface ? '#18181b' : '#f4f4f5';
  const mutedText = isLightSurface ? '#71717a' : '#a1a1aa';
  const trackColor = isLightSurface ? 'rgba(24,24,27,.08)' : 'rgba(255,255,255,.11)';
  return (
    <div style={{ minHeight:'100vh', background, color:primaryText, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
      <div className="app-bootstrap-card" style={{ textAlign:'center', width:'min(280px, 82vw)' }}>
        <div style={{ display:'flex', justifyContent:'center', marginBottom:12 }}>
          <BrandLogo brand={brand} variant="full" surfaceTone={surfaceTone} imgStyle={{ height: 38, maxWidth: 220 }} fallbackStyle={{ fontSize: 24, color: primaryText }} />
        </div>
        <div style={{ fontSize:12, color:mutedText, letterSpacing:0, marginBottom:14 }}>Preparando tu espacio de trabajo...</div>
        <div aria-hidden="true" style={{ height:3, width:'100%', overflow:'hidden', borderRadius:999, background:trackColor }}>
          <div className="app-bootstrap-progress" style={{ height:'100%', width:'38%', borderRadius:999, background:'var(--accent, #ffa8a8)' }} />
        </div>
      </div>
    </div>
  );
}
